export const authRoles = {
  sa: ["SA"], // Only Super Admin has access
  admin: ["SA", "ADMIN"], // Only SA & Admin has access
  candidate: ["SA", "ADMIN", "CANDIDATE"],
  company: ["SA", "ADMIN", "COMPANY"],
  guest: ["GUEST"] // Everyone has access
};
